import { toAppError } from '../../utils/backendGatewayError';
import type { AppError } from '../../utils/firebaseErrors';

export const REPORT_INVALID_QUERY_CODE = 'reports/invalid-query';
export const REPORT_INVALID_QUERY_MESSAGE_KEY = 'reports:errors.invalidQuery';

const REPORT_INVALID_QUERY_REASON = 'invalid-query';

export const toReportInvalidQueryError = (error: unknown): AppError => {
  const appError = toAppError(error, REPORT_INVALID_QUERY_CODE);

  return {
    ...appError,
    code: REPORT_INVALID_QUERY_CODE,
    reason: REPORT_INVALID_QUERY_REASON,
    messageKey: REPORT_INVALID_QUERY_MESSAGE_KEY,
  };
};
